const popins = {

	state : {
	  	list: [],
	  	loadingList: false,
	  	selected: {}
	},

	reducer : (state, action) => {
	  switch(action.type) {
	  	case "startPaopin": {
	      	return { ...state, loadingList:true }
	    }
	    case "endPopins": {
	      	return { ...state, loadingList:false }
	    }
	    case "setPopins": {
	      	return { ...state, list:action.data, loadingList:false }
	    }
	    case "setPopinSelected": {
	      	return { ...state, selected:action.data }
	    }
	    case "resetPopins": {
	    	return { ...state, list:[], loadingList:false, selected:{} }
	    }
	    default:
	    	// Do nothing
	  }
	  return state;
	}
}

export default popins